export default "__VITE_ASSET__BwbVooxa__"